import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { NestedThreadListLoadFulfilledAction } from '../../domains/nestedThreadList/actions.types';

import { SenderLeaders } from './types';

export type SenderLeaderAction = NestedThreadListLoadFulfilledAction;

const initialState: SenderLeaders = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<SenderLeaders, SenderLeaderAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'NESTED_THREAD_LIST.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.senderLeaders);
    default:
      return state;
  }
};

export default reducer;
